<template>
  <div>
    <BaseTitle :title="$t('content.school_management')" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              :items="provinces"
              :label="$t('province')"
              :loading="loadingProvinces"
              item-value="provinceId"
              item-text="name"
              clearable
              v-model="form.province"
              @change="getCities"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              :items="cities"
              :label="$t('city')"
              :loading="loadingCities"
              item-value="cityId"
              item-text="name"
              clearable
              v-model="form.city"
              @change="getCity"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              :items="educationList"
              :label="$t('content.education_level')"
              :loading="loadingEducation"
              item-value="educationalLevel"
              item-text="educationalLevel"
              clearable
              v-model="form.educationalLevel"
              @change="getData"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select :items="lockItems" :label="$t('form.datatype')" clearable v-model="form.isSynced" @change="getData" />
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div class="pa-3">
        <div class="ml-5 mt-3 mr-5">
          <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
          <v-data-table
            :headers="tableHeader"
            :items="items"
            :loading="table.loading"
            :server-items-length="items.length"
            :options.sync="table.options"
            hide-default-footer
            class="table-custom"
          >
            <template #top>
              <table-header @fetch="getData">
                <template #left>
                  <v-dialog v-model="dialogSync" persistent max-width="800">
                    <v-card>
                      <div class="d-flex justify-center">
                        <svg-icon icon="clock-master" class="succ-featured pa-10" width="300" height="250" />
                      </div>
                      <v-card-title v-if="loadingSync === true" class="d-flex justify-center">
                        <v-progress-linear indeterminate color="secondary" class="mb-0" />
                      </v-card-title>
                      <v-card-title v-if="loadingSync === false" class="headline d-flex justify-center assignment-content"
                        >{{ $t('content.dialog_school_title') }}
                      </v-card-title>
                      <v-card-title v-else class="headline d-flex justify-center assignment-content">{{
                        $t('content.dialog_school_title_v1')
                      }}</v-card-title>
                      <v-card-text v-if="loadingSync === true" class="d-flex justify-center">{{ $t('content.dialog_school_content') }}</v-card-text>
                      <v-card-text v-else class="d-flex justify-center">{{ $t('content.dialog_school_content_v1') }}</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :disabled="loadingSync" class="btn-primary-custom mr-3" outlined @click="dialogSync = false">{{
                          $t('cancel')
                        }}</v-btn>
                        <v-btn color="primary" :loading="loadingSync" class="btn-primary-custom" @click="synSchool">
                          OK
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- <v-btn color="primary" :loading="loadingSync" disabled @click="dialogSync = true" class="btn-primary-custom mb-2 mb-md-0 mr-md-2">{{
                    $t('content.sync')
                  }}</v-btn> -->
                </template>
                <!-- <template #bot>
                  <span
                    >{{ $t('content.last_sync') }}:
                    <strong v-if="listSchool.lastSync" style="color: #56A6DC"> {{ listSchool.lastSync }}</strong>
                    <strong v-else style="color: #56A6DC">-</strong>
                  </span>
                </template> -->
              </table-header>
            </template>
            <template #item.schoolNumber="{ item }">
              <span v-if="item.schoolNumber">{{ item.schoolNumber }}</span>
              <span v-else>-</span>
            </template>
            <template #item.educationalLevel="{ item }">
              <span v-if="item.educationalLevel">{{ item.educationalLevel }}</span>
              <span v-else>-</span>
            </template>
            <template #item.address="{ item }">
              <span v-if="item.address">{{ item.address }}</span>
              <span v-else>-</span>
            </template>
            <template #item.synced="{ item }">
              <strong class="sync" v-if="item.synced === true">{{ $t('content.sync') }}</strong>
              <strong class="sync-manual" v-else>Manual</strong>
            </template>
            <template #item.actions="{ item }">
              <v-btn text v-if="item.synced === false" @click="editItem(item)" class="btn-action-custom"
                ><svg-icon icon="edit" class="primary--text"
              /></v-btn>
              <span v-else>-</span>
            </template>
            <!-- <template #no-data><NoData /></template> -->
            <template #loading>
              <img src="@/assets/images/globe.gif" class="pa-4" />
            </template>
          </v-data-table>
          <table-footer @fetch="getData" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import TableHeader from '@/components/table/TableHeader';
import TableFooter from '@/components/table/TableFooter';
// import NoData from '@/components/table/NoData';

import { required } from 'vuelidate/lib/validators';
import { fileSize, fileType } from '@/validators';

const extAllowed = ['xls', 'xlsx'];

export default {
  name: 'MasterSchool',
  components: {
    BaseTitle,
    TableHeader,
    TableFooter
    // NoData
  },
  computed: {
    ...mapGetters({
      items: 'SchoolManage/items',
      provinces: 'Reference/itemProvinces'
    }),
    lockItems() {
      return [
        { text: this.$t('content.sync'), value: true },
        { text: 'Manual', value: false }
      ];
    },
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    },
    tableHeader() {
      return [
        { text: 'NPSN', value: 'schoolNumber' },
        { text: this.$t('content.education_level'), value: 'educationalLevel', width: 100 },
        { text: this.$t('form.school'), value: 'schoolName', align: 'center' },
        { text: this.$t('table.province'), value: 'province', width: 100 },
        { text: this.$t('table.city'), value: 'city', align: 'center' },
        { text: this.$t('form.address'), value: 'address', align: 'center' },
        { text: this.$t('form.datatype'), value: 'synced', width: 100 },
        { text: this.$t('table.action'), value: 'actions', sortable: false, align: 'center' }
      ];
    }
  },
  validations() {
    return {
      formImport: {
        file: {
          required,
          fileSize: fileSize(500),
          fileType: fileType(extAllowed)
        }
      }
    };
  },
  data: () => ({
    currentItem: null,
    loadingCities: false,
    loadingProvinces: false,
    loadingEducation: false,
    loadingSync: false,
    loadingLoad: false,
    dialogSync: false,
    listSchool: [],
    search: '',
    educationList: [],
    synList: [],
    form: {
      city: '',
      province: '',
      isSynced: '',
      educationalLevel: ''
    },
    formImport: {
      file: null
    },
    table: {
      loading: false,
      options: {}
    }
  }),
  methods: {
    getData() {
      // if (this.form.city) {
      //   this.getCity();
      // } else {
      this.loadingLoad = true;
      this.$store
        .dispatch('SchoolManage/fetchList', {
          educationalLevel: this.form.educationalLevel,
          provinceId: this.form.province,
          cityId: this.form.city,
          search: this.search,
          isSynced: this.form.isSynced
        })
        .then(data => (this.listSchool = data))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingLoad = false));
      // }
    },
    editItem({ masterSchoolId }) {
      this.$router.push({ name: 'SchoolV1Edit', params: { id: masterSchoolId } });
    },
    getEducation() {
      this.loadingEducation = true;
      this.$store
        .dispatch('School/getEducation', this.form.city)
        .then(res => (this.educationList = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingEducation = false));
    },
    synSchool() {
      this.loadingSync = true;
      this.$store
        .dispatch('SchoolManage/syncSchool')
        .then(res => (this.synList = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.loadingSync = false;
          this.dialogSync = false;
          this.getData();
        });
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => (this.loadingProvinces = false));
    },
    getCity() {
      if (this.form.city) {
        this.getEducation();
        this.loadingLoad = true;
        this.$store
          .dispatch('SchoolManage/fetchList', {
            cityId: this.form.city,
            search: this.search
          })
          .then(data => (this.listSchool = data))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loadingLoad = false));
      } else {
        this.getData();
      }
    },
    getCities() {
      this.getData();
      if (!this.form.province) {
        this.$store.commit('Reference/RESET_CITIES');
        this.form.city = null;
        this.getCity();
        return;
      }
      this.loadingCities = true;
      this.$store.dispatch('Reference/fetchCities', this.form.province).finally(() => (this.loadingCities = false));
    }
  },
  created() {
    this.getData();
    this.$store.commit('table/RESET_PAGEABLE');
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}

.sync {
  color: #6dd400;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.sync-manual {
  color: #fa6400;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
